import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles, Theme } from '@material-ui/core/styles'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import clsx from 'clsx'
import React, { useState } from 'react'
import 'react-image-gallery/styles/css/image-gallery.css'

const verticalIconButtonStyles = makeStyles((theme: Theme) => ({
    vertIconButton: {
        color: '#fff',
        position: 'absolute',
        top: theme.spacing(1),
        background: 'rgba(0,0,0,0.25)',
        border: '1px solid rgba(255,255,255,0.3)',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            right: theme.spacing(0.5),
        },
        '&:hover': {
            background: 'rgba(0,0,0,0.25)',
            border: '1px solid rgba(255,255,255,0.3)',
        },
    },
    menuPopoverPaper: {
        marginTop: theme.spacing(1.5),
        '&>ul': {
            paddingTop: theme.spacing(0.5),
            paddingBottom: theme.spacing(0.5),
            color: theme.palette.primary.main,
        },
    },
}))

export interface VerticalIconButtonProps {
    setOpenDialog: (open: boolean) => void
}

const VerticalIconButton = ({ setOpenDialog }: VerticalIconButtonProps) => {
    const classes = verticalIconButtonStyles()
    const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null)
    const menuOpen = Boolean(menuAnchorEl)

    const handleIconButtonClick = (e: React.MouseEvent<HTMLElement>) => {
        setMenuAnchorEl(e.currentTarget)
    }

    const handleMenuItemClose = () => {
        setMenuAnchorEl(null)
    }

    const handleMenuItemClick = () => {
        setOpenDialog(true)
        setMenuAnchorEl(null)
    }

    return (
        <>
            <IconButton
                className={clsx('verticalIconButton', classes.vertIconButton)}
                onClick={handleIconButtonClick}
                size="small"
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                open={menuOpen}
                anchorEl={menuAnchorEl}
                keepMounted
                onClose={handleMenuItemClose}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PopoverClasses={{
                    paper: classes.menuPopoverPaper,
                }}
            >
                <MenuItem onClick={handleMenuItemClick}>
                    Manage Photos and Videos
                </MenuItem>
            </Menu>
        </>
    )
}

export default VerticalIconButton
